/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { IconUpload, IconX } from "@tabler/icons-react";
import SelectInput from "../../../components/Select"; 
import { useForm } from "react-hook-form";
import Input from "../../../components/Input";
import ToggleButton from "../../../components/ToggleButton";
import FileUploader from "../../../components/common/FileUploader";
import Radio from "../../../components/common/Radio";
import CoverageCities from "./CoverageCities";
type Props = {
  open: boolean; // ✅ Add this line
  onClose: () => void;
  selectedWarehouse: string;
};



type CoverageFormValues = {
  warehouseId: string;
  covrageCountry: string | null;
  covrageName: string;
  covrageCity: string | null;
  covrageType: string;
  covrageCities: string[];
  status?: boolean;
};

export default function AddTireModal({
  onClose,
  selectedWarehouse,
}: {
  onClose: () => void;
  selectedWarehouse: string;
}) {
  const [selectedCitiesArray, setSelectedCitiesArray] = useState<any>();
  const [selectedCoverageCountry, setSelectedCoverageCountry] = useState<any>();
  const [selectedCoverageCity, setSelectedCoverageCity] = useState<any>();
  const [error, setError] = useState<string>("");
  const [checked, setChecked] = useState<boolean>(false);

  // Dummy data
  const countries = [
    { id: "1", name: "Saudi Arabia" },
    { id: "2", name: "UAE" },
  ];
  const citiesData = [
    { id: "11", name: "Riyadh" },
    { id: "12", name: "Jeddah" },
  ];
  const districtData = [
    { id: "111", name: "Al Olaya" },
    { id: "112", name: "Al Malaz" },
  ];

  const {
    register: coverageRegister,
    handleSubmit: coverageSubmit,
    clearErrors: coverageClearErrors,
    reset: coverageReset,
    watch: coverageWatch,
    formState: { errors: coverageErrors },
    setValue,
  } = useForm<CoverageFormValues>();

  const handleCreate = (formData: CoverageFormValues) => {
    if (!selectedCitiesArray || selectedCitiesArray?.length === 0) {
      setError("Please select minimum one city");
      return;
    }
    setError("");
    const country: any = coverageWatch("covrageCountry");
    const city: any = coverageWatch("covrageCity");

    const payload = {
      ...formData,
      covrage: selectedCitiesArray,
      warehouseId: selectedWarehouse,
      covrageCountry:
        coverageWatch("covrageType") === "city" ||
        coverageWatch("covrageType") === "district"
          ? country?.id
          : null,
      covrageCity:
        coverageWatch("covrageType") === "district" ? city?.id : null,
    };
    console.log("Submitting coverage:", payload);
    onClose();
    coverageReset();
  };

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-[#F7F6F2] rounded-2xl">
        <div className="flex items-center justify-between px-4 py-4 border-b border-[#d2d2d2]">
          <h2 className="text-2xl">Create Coverage Area</h2>
          <button
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer"
            onClick={onClose}
          >
            <IconX size={24} />
          </button>
        </div>

        <div className="w-[800px] max-h-[600px] overflow-hidden overflow-y-auto p-4 space-y-4">
          <div className="space-y-6 w-full">
            <div className="flex justify-between items-center">
              <h2 className="text-[#000000]/70 text-base">
                Choose Bulk Upload
              </h2>
              <div className="flex items-center gap-1">
                <ToggleButton
                  onChange={() => setChecked(!checked)}
                  checked={checked}
                />
                <h2 className="text-[#000000]/70 text-base">Bulk Upload</h2>
              </div>
            </div>

            {checked ? (
              <>
                <FileUploader
                  name="document"
                  classNameMain="bg-white outline-2 outline-dashed outline-[#212121]/10"
                  title="Upload Your File"
                  message="Accepted formats: .xls, .xlsx, .csv | Max: 5MB"
                  placeHolder=""
                  img="/img/upload-img.png"
                  classNameImgDiv=" flex flex-col items-center justify-center"
                  uploadType="document"
                />
                <ul className="list-disc px-6 text-[#1E293B] text-sm">
                  <li>Download the Excel/CSV template before uploading. </li>
                  <li>Do not change column headers.</li>
                </ul>
                <div className="bg-[#ffffff] flex justify-between items-center px-4 py-2 rounded col-span-2">
                  <p className="text-xs w-full">
                    <b className="text-[#EC221F]">Note</b>: Please upload the
                    file in the same format as the downloaded file
                  </p>
                  <div className="w-full flex justify-end items-end">
                    <button className="bg-[#000000] text-white px-4 py-2 rounded flex items-center gap-1 text-xs">
                      <img src="/img/csvxl.svg" alt="" /> Download
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="grid grid-cols-2 gap-4">
                <Input
                  name="covrageName"
                  type="text"
                  title="Coverage Name"
                  placeholder="e.g. Central Riyadh, Western Jeddah"
                  other={{
                    className:
                      "w-full space-y-1 px-4 py-2 text-sm rounded-full outline-none bg-white border border-[#D8D8D8]",
                  }}
                  register={coverageRegister}
                  error={coverageErrors?.covrageName}
                  validation={{
                    required: "Coverage name is required",
                    validate: (value: string) => {
                      const trimmed = value.trim();
                      if (trimmed.length < 3)
                        return "Coverage name must be at least 3 characters";
                      if (trimmed.length > 30)
                        return "Coverage name must be at most 30 characters";
                      return true;
                    },
                  }}
                />

                <Radio
                  name="covrageType"
                  label="Select Coverage Type"
                  valuesArr={[
                    { value: "country", text: "Country" },
                    { value: "city", text: "City" },
                    { value: "district", text: "District" },
                  ]}
                  register={coverageRegister}
                  validation={{ required: "Coverage type is required" }}
                  error={coverageErrors.covrageType}
                />

                {(coverageWatch("covrageType") === "city" ||
                  coverageWatch("covrageType") === "district") && (
                  <SelectInput
                    name="covrageCountry"
                    label="Country"
                    placeholder=""
                    selectOptions={countries.map((country) => ({
                      id: country.id,
                      value: country.name,
                      text: country.name,
                    }))}
                    register={coverageRegister}
                    clearErrors={coverageClearErrors}
                    validation={{ required: "Please select a country" }}
                    error={coverageErrors?.covrageCountry}
                    value={selectedCoverageCountry?.name}
                  />
                )}

                {coverageWatch("covrageType") === "district" && (
                  <SelectInput
                    name="covrageCity"
                    label="Select City"
                    selectOptions={citiesData.map((city) => ({
                      id: city.id,
                      value: city.name,
                      text: city.name,
                    }))}
                    register={coverageRegister}
                    clearErrors={coverageClearErrors}
                    validation={{ required: "City is required" }}
                    error={coverageErrors.covrageCity}
                    value={selectedCoverageCity?.name}
                  />
                )}

                {(coverageWatch("covrageType") === "country" ||
                  (coverageWatch("covrageType") === "city" &&
                    coverageWatch("covrageCountry")) ||
                  (coverageWatch("covrageType") === "district" &&
                    coverageWatch("covrageCity"))) && (
                  <div className="bg-[#FCFDF8]/90 p-2 rounded-lg col-span-2">
                    <CoverageCities
                      ALL_CITIES={
                        coverageWatch("covrageType") === "country"
                          ? countries
                          : coverageWatch("covrageType") === "city"
                          ? citiesData
                          : districtData
                      }
                      selectedCityData={[]}
                      coverageType={coverageWatch("covrageType")}
                      setSelectedCitiesArray={setSelectedCitiesArray}
                      error={error}
                      setError={setError}
                      isEdit={false}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="border-t border-[#D8D8D8] px-4 py-4 flex justify-end space-x-2">
          <button
            className="border border-[#D8D8D8] bg-transparent flex items-center rounded-full p-2 px-4 space-x-1 cursor-pointer text-base font-medium"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            onClick={coverageSubmit(handleCreate)}
            className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
